export default __webpack_public_path__ + "static/media/AnandaShowroomFloorPlan.cc2be93d.png";